import { ParamMap } from '@angular/router';
import { BreadcrumbItem } from '@woolworthsnz/styleguide';

export const generateBreadcrumb = (
	searchPath: string,
	queryParamMap: ParamMap,
	storeId: number,
	storeName: string,
	storePath: string
): BreadcrumbItem[] => {
	const breadcrumbs: BreadcrumbItem[] = [
		{
			text: 'Store finder',
			routeUrl: `/${storePath}`,
			queryParams: null,
		},
	];

	// if coming from the search results page we want to be able to get back to it
	const lat = queryParamMap.get('lat');
	const long = queryParamMap.get('long');

	if (lat && long) {
		const q = queryParamMap.get('q');
		breadcrumbs.push({
			text: 'Results',
			routeUrl: searchPath,
			queryParams: { q, lat, long },
		});
	}

	// Last breadcrumb is the store name and does not have a link
	breadcrumbs.push({
		text: storeName,
		queryParams: null,
	});

	return breadcrumbs;
};
